/**
 * KIMLIK SABITLERI — sunucu ve arayuz AYNI sayiyi kullanir
 *
 * ================================================================
 * NEDEN BURADA
 * ================================================================
 * Bu sayilar kullaniciya METIN olarak gosteriliyor: "Bağlantı 30
 * dakika geçerlidir", "Kod 30 saniye sonra yenilenir", "10 yedek
 * kod". Arayuz onlari kendi dosyasina yazdiginda IKI GERCEK olusuyor
 * ve biri sessizce eskiyor.
 *
 * Nitekim eskimisti: 04.09.2026'da giris ekrani cizime gore yeniden
 * giydirilirken panelin "Bağlantı 7 gün geçerlidir" dedigi goruldu.
 * Sunucudaki gercek deger 30 DAKIKA idi ve o gun de oyleydi — yani
 * panel, kullaniciya bir gun boyunca gecerli olmayan bir baglantiyi
 * beklemesini soyluyordu.
 *
 * Sunucu tarafi bu degerleri `apps/api/src/modules/auth/jeton.ts`
 * icinde KENDI adlariyla tutmaya devam ediyor; oradaki tanimlar
 * buradan besleniyor, tersi degil.
 */

/** Sifre sifirlama baglantisinin gecerlilik suresi (dakika) — G-AUT-08. */
export const SIFRE_SIFIRLAMA_DAKIKA = 30;

/**
 * Davet baglantisinin gecerlilik suresi (gun) — F-PPL-01b.
 *
 * Sifre sifirlamadan uzun: davet e-postasi genelde is akisinin icinde
 * beklenmez, kullanici ertesi gun acar.
 *
 * Panelde IKI ayri ekranda METIN olarak gosteriliyor (`JetonSayfasi`,
 * `Personel`) — bu yuzden burada. Elle yazilmis hali dogruydu ama
 * "Baglanti 7 gun gecerlidir" cumlesi sunucudaki degerden bagimsizdi;
 * ayni sinif hata sifre sifirlamada GERCEKTEN olmustu (panel 7 gun
 * diyordu, sunucu 30 dakikaydi).
 */
export const DAVET_GUN = 7;

/** TOTP penceresi (saniye). Standart deger; degistirilirse uygulamalar uyumsuz kalir. */
export const TOTP_PENCERE_SANIYE = 30;

/** 2FA kurulumunda uretilen tek kullanimlik yedek kod sayisi — G-AUT-02. */
export const YEDEK_KOD_SAYISI = 10;

/**
 * Guvenilir cihazin gecerlilik suresi (gun) — G-AUT-01c.
 *
 * SARTNAME BU SAYIYI KODA GOMULU TUTUYOR (G-AUT-01c, kural 8): giris
 * ekranindaki "Bu cihazi 30 gun hatirla" etiketi ile sunucudaki sure
 * IKI AYRI GERCEK olamaz. Ayardan degistirilebilir yapilacaksa sunucu
 * sayiyi arayuze GONDERMELI; o zamana kadar tek kaynak burasi.
 */
export const GUVENILIR_CIHAZ_GUN = 30;

/**
 * Ayni veliye iki muvafakat hatirlatmasi arasinda gecmesi gereken
 * EN AZ gun sayisi — F-LGL-05.
 *
 * ================================================================
 * BU SAYI EMRE'NIN ONAYINI BEKLIYOR
 * ================================================================
 * Sartname bunu acikca yaziyor: 7 bir ONERI, sozlesme degil.
 * Dayanagi F-SRV-04 (bir veliye ayda en fazla bir anket) ama pencere
 * BILEREK daha kisa: anket bir rica, muvafakat ise ENGELLEYICI —
 * alinmadigi surece cocugun hesabi acilmiyor. Ayda bir hatirlatmak,
 * ogrenciyi bir ay boyunca sistemin disinda tutmak demek olurdu.
 *
 * Arayuz bu sayiyi ELLE YAZMAYACAK: "7 gün içinde zaten hatırlatıldı"
 * cumlesi buradan beslenir. Iki yere yazilan bir sure bu depoda daha
 * once ayrisip kullaniciya yanlis metin gostermisti
 * (SIFRE_SIFIRLAMA_DAKIKA, ayni dosya).
 */
export const MUVAFAKAT_HATIRLATMA_GUN = 7;

/**
 * Bir gorunum oturumunun EN FAZLA suresi (dakika) — F-AUTH-07.
 *
 * ================================================================
 * NEDEN SOZLESMEDE
 * ================================================================
 * Bu sayi kullaniciya METIN olarak gosteriliyor: "En fazla 30 dakika
 * surer" hem hedefe giden bildirimde hem gorunum seridinde yaziyor.
 * Arayuz kendi dosyasina yazdiginda IKI GERCEK olusuyor ve biri
 * sessizce eskiyor — panel "30 dakika" derken sunucu 15'e dusmus
 * olabilir ve kimse patlamaz, yalnizca kullaniciya yanlis soylenir.
 *
 * Ayni sinif hata bu depoda GERCEKTEN olmustu (SIFRE_SIFIRLAMA_DAKIKA,
 * bu dosyanin basinda). Panel oturumu ekrandaki "30 dakika"yi
 * kaldirdi ve sabitin buraya tasinmasini istedi; yerinde bir istek.
 */
export const GORUNUM_AZAMI_DAKIKA = 30;
